import profile from './profile';
import careerProfile from './careerProfile';
import experiences from './experiences';
// import tags from './tags';

export const data = {
  profile,
  careerProfile,
  experiences,
  // tags
};

export default data;



// WEBPACK FOOTER //
// ./src/data/index.js